module.exports = __webpack_public_path__ + "static/img/16.0b45e06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/16.jpg
// module id = BB4J
// module chunks = 5